import React from "react";
import { Box } from "design_system/Layout";
import { TranslationSupportCTA } from "widgets/CTAs";

import { useShowTranslationCalloutQuery } from "../../hooks/queries/useShowTranslationCalloutQuery";
import { useHideTranslationCalloutMutation } from "../../hooks/mutations/useHideTranslationCalloutMutation";
import { useTranslationSupportQuery } from "../../hooks/queries/useTranslationSupportQuery";

export const TranslationSupportCallout = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const userPublicId = searchParams.get("user") as string;
    const linkHash = searchParams.get("link") as string;

    if (!userPublicId && !linkHash) return null;

    const { data: translationSupportData } = useTranslationSupportQuery({
        userPublicId,
        linkHash,
    });

    const ctaMessage =
        translationSupportData?.customer?.patientAppTranslationSupportContext?.ctaMessage;

    const { data: showTranslationCalloutData } = useShowTranslationCalloutQuery({
        variables: { userPublicId, linkHash },
    });
    const showTranslationCallout =
        showTranslationCalloutData?.customer?.userData?.showTranslationCallout;
    const [hideTranslationCallout] = useHideTranslationCalloutMutation({
        variables: { userPublicId, linkHash },
    });

    if (!showTranslationCallout || !ctaMessage) return null;

    return (
        <Box w="s992:w-10/12" p="pt-32" m="s1200:ml-3em s992:mx-auto">
            <TranslationSupportCTA
                onClose={() => hideTranslationCallout()}
                ctaMessage={ctaMessage}
            />
        </Box>
    );
};
